/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spry_Tired_Tiger_LendInputs */

const fr_spry_tired_tiger_lend = /** @type {(inputs: Spry_Tired_Tiger_LendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher un exercice`)
};

/**

* @param {Spry_Tired_Tiger_LendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const spry_tired_tiger_lend = /** @type {((inputs?: Spry_Tired_Tiger_LendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spry_Tired_Tiger_LendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_spry_tired_tiger_lend(inputs)
});